<template>
  <div id="app">
    <router-view />
    <upgrade v-if="showupgrade" />
  </div>
</template>
<script>
export default {
  components: {
    upgrade: () => import("./pages/upgrade/upgrade.vue"),
  },
  data() {
    return {
      showupgrade: true,
    };
  },
  created() {
    let version=window.remote.app.getVersion();
    let splits = version.split(".");
    if (splits.length == 3 && parseInt(splits[2]) > 13) {
      this.showupgrade = false;
    }
    console.log(version);
  },
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue